import React, { useState } from 'react';
import ReportModal from './ReportModal';
import './AiContentNotice.css';

// Always-visible "AI content · Report" affordance rendered on every
// surface that shows model output (Chat, Image gen, Companion chat).
// Required by Google Play's Generative AI / AI-Generated Content
// policy and the App Store's equivalent — the policy says the report
// affordance must be findable WITHOUT the user having to generate
// content first. Per-card Report buttons still exist for specific-item
// reports; this notice is the belt-and-suspenders global entry point
// that reviewers see at first glance.
//
// Props:
//   kind — 'image' | 'chat' | 'companion' (passed to reportContent so
//          the moderation queue can route it)
//   meta — extra context ({ page: 'image-generator' } etc.)
export default function AiContentNotice({ kind = 'chat', meta = {} }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="ai-notice" role="note">
        <svg
          className="ai-notice-icon"
          width="12" height="12" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span className="ai-notice-text">Content is AI-generated and may be inaccurate.</span>
        <button
          type="button"
          className="ai-notice-btn"
          onClick={() => setOpen(true)}
          aria-label="Report offensive AI-generated content"
        >
          Report content
        </button>
      </div>
      <ReportModal
        open={open}
        onClose={() => setOpen(false)}
        kind={kind}
        content=""
        meta={{ ...meta, source: 'global-notice' }}
      />
    </>
  );
}
